var moduleMap = {
	"./PatientDetails": () => {
		return Promise.all([__webpack_require__.e(6550), __webpack_require__.e(8998), __webpack_require__.e(446), __webpack_require__.e(3845), __webpack_require__.e(5360), __webpack_require__.e(2667), __webpack_require__.e(7271), __webpack_require__.e(2950), __webpack_require__.e(7650), __webpack_require__.e(4577), __webpack_require__.e(6045), __webpack_require__.e(6137), __webpack_require__.e(8372), __webpack_require__.e(6677), __webpack_require__.e(2579), __webpack_require__.e(221), __webpack_require__.e(5990)]).then(() => (() => ((__webpack_require__(43779)))));
	},
	"./HeaderPatient": () => {
		return Promise.all([__webpack_require__.e(6550), __webpack_require__.e(5360), __webpack_require__.e(7271), __webpack_require__.e(2950), __webpack_require__.e(4577), __webpack_require__.e(6045), __webpack_require__.e(6137), __webpack_require__.e(8372), __webpack_require__.e(2130)]).then(() => (() => ((__webpack_require__(12130)))));
	},
	"./CardsFlagsAlerts": () => {
		return Promise.all([__webpack_require__.e(6550), __webpack_require__.e(5483), __webpack_require__.e(7271), __webpack_require__.e(2950), __webpack_require__.e(4577), __webpack_require__.e(6045), __webpack_require__.e(6137), __webpack_require__.e(1046)]).then(() => (() => ((__webpack_require__(41046)))));
	},
	"./PatientOverview": () => {
		return Promise.all([__webpack_require__.e(7271), __webpack_require__.e(2950), __webpack_require__.e(6045), __webpack_require__.e(2579), __webpack_require__.e(58)]).then(() => (() => ((__webpack_require__(60058)))));
	}
};
var get = (module, getScope) => {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(() => {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
var init = (shareScope, initScope) => {
	if (!__webpack_require__.S) return;
	var name = "default"
	var oldScope = __webpack_require__.S[name];
	if(oldScope && oldScope !== shareScope) throw new Error("Container initialization failed as it has already been initialized with a different share scope");
	__webpack_require__.S[name] = shareScope;
	return __webpack_require__.I(name, initScope);
};

// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: () => (get),
	init: () => (init)
});